var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/fgk-yproduct.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [
                    _vm._v("\n\t\t\t\t\t\t高空雇主险-\n\t\t\t\t\t\t"),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("钢结构（优惠版）"),
                    ]),
                  ]),
                  _c("div", [_vm._v("专属方案 | 中国太平洋承保 | 全线上操作")]),
                  _c("p", [
                    _vm._v(
                      "\n\t\t\t\t\t\t① 可保钢结构、钢骨结构、机械设备拆除工\n\t\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t\t② 保额最高120万，社保用药、误工费有保障\n\t\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t\t3人起保，无安全带/无特种证不拒赔，性价比高\n\t\t\t\t\t"
                    ),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "25px" },
                      attrs: {
                        loading: _vm.isDownLoading,
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t\t下载太保职业类别表\n\t\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c("avue-crud", {
                    ref: "plan",
                    attrs: {
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "钢结构、钢骨结构、机械设备拆除工" } },
                [
                  _c("avue-crud", {
                    ref: "premiumRestrict",
                    attrs: {
                      data: _vm.dataPremiumRestrict,
                      option: _vm.optionPremiumRestrict,
                      "span-method": _vm.spanMethodPremiumRestrict,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "赔付标准" } },
                [
                  _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "500",
                          color: "Red",
                          "margin-bottom": "20px",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t社保用药范围100%赔付，伤残等级对应赔付比例请查看附表\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: {
                        data: _vm.dataBenefit,
                        option: _vm.optionBenefit,
                      },
                    },
                    [_c("template", { slot: "header" })],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(qa.question))]
                              ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "background-color": "MediumSeaGreen",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c("span", [_vm._v(_vm._s(qa.answer))]),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("h3", [_vm._v("保险条款及须知")]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t1. 本保险适用以下保险条款\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "link" }, [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "DodgerBlue" },
                              attrs: {
                                href: "fgkclause.html",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t中国太平洋财产保险股份有限公司雇主责任保险条款\n\t\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t2、本保险由中国太平洋财产保险股份有限公司承保，承保区域为全国范围（港澳台除外）。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t3、保险公司设有省级分支机构和落地服务机构的省清单见如下链接：\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "link" }, [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "DodgerBlue" },
                              attrs: {
                                href: "http://property.cpic.com.cn/xccbx/gygs/fzjg/index.shtml?skip=",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t省级分支机构和落地服务机构\n\t\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t4、保险公司全国统一的客户服务及投诉方式详见如下链接：\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "link" }, [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "DodgerBlue" },
                              attrs: {
                                href: "http://property.cpic.com.cn/xccbx/gkxxbl/jbxx/gsgk/?subMenu=1&inSub=1",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t全国统一的客户服务及投诉方式\n\t\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t5、在投保本保险前请您认真阅读《\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("雇主责任"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款（包括但不限于责任免除、\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("免赔额"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t、投保人被保险人义务等）。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t7、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t8、\n\t\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("本保险提供电子发票。"),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t9、本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t10、如被保险人未有员工出险，则保险人收取最低保费后，允许保单退保，并退还剩余保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                      ]),
                      _c("el-divider"),
                      _c("h3", [_vm._v("特别约定")]),
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "line-height": "32px",
                            "font-weight": "normal",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t1、被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，免赔50%。如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t2、出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打本保单第22或23条特别约定中的电话号码，取得报案号后才是报案成功（否则报案失败）。如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第1条特别约定扣除免赔，那么被保险人须自行承担相关损失。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t3、被保险人雇员的年龄限16-65周岁（不超65），本方案每人限投1份，超过部分无效。被保险人雇员由于工作原因受到伤害，依照《工伤保险条例》及相关法律应当认定为工伤或视同工伤的，对于被保险人依法应承担的经济赔偿责任，保险人在本保单的责任限额内予以赔付。本保单不承保承揽关系。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t4、本保单可加人（不足1个月的按1个月收费），不可减人。保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人，换人规则：原4-5类职业人员可替换为新的4-5类职业人员，原6类职业人员可替换为新的6类职业人员，4-5类职业人员和6类职业人员之间不可互换。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t5、如被保险人未有员工出险，则保险人收取最低保费后，允许保单退保，并退还剩余保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t6、本保单承保如下类职业（含高处作业）：钢结构、钢骨结构、机械设备拆除工。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t7、本保单拒绝承保职业：水下作业、地下作业、海上作业（渔业、油矿开采等）、矿业/采石业、森林防火员、体育运动、影视及演艺业、战地记者、驯兽师、钢丝绳生产加工、塔吊安装拆除和维修、铁塔架设和拆除、窑炉/烟囱新建和拆除、高炉相关工作、金属冶炼、钢缆生产加工、船舶/化工/军工相关工作、涉及火药/炸药/爆破的相关工作、保安/保镖、特种兵/军人/武警/公安/警察/消防等治安人员、大型管道（水下或地下）/公路/山路/铁路/桥梁/水利/隧道工程、建筑拆除。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t8、被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保职业）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，免赔20%。如属于拒绝承保职业，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t9、在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔款=每人身故赔偿限额*20%。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t10、在本保单有效期内，被保险人雇员在从事与本保单所载明的被保险人的业务工作而罹患与业务有关的国家规定的职业性疾病的，须提供县级以上医院或疾控中心出具的相关确诊证明。确诊证明资料载明职业病罹患时间在本保单保险责任起始日期之前的，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t11、如被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t12、如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t13、按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例40%，七级伤残给付比例30%，八级伤残给付比例10%，九级伤残给付比例7%，十级伤残给付比例5%。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t14、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t15、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。被保险人雇员仅接受门诊治疗的，按本保单约定无误工费赔付。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t16、本保单不承担任何性质的精神损害赔偿责任。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t17、被保险人雇员无安全带或者无特种作业操作证（包括但不限高处作业证），保险人承诺不拒赔；从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，免赔35%。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t18、本保单指定就诊医院为大陆境内二级及以上公立医院，但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市。如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t19、在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t20、以下情形，保险人不得以保单上列明职业有误而拒赔或者减少承担赔偿责任：保单上列明职业类别对应的保费，不低于被保险人实际职业类别对应的保费。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t21、兹经双方确认，因保险合同纠纷提起的诉讼，由被告住所地的人民法院管辖。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t22、如您不幸发生事故，或需要咨询保险相关事宜，请及时拨打服务热线：400-180-1616，获取工作人员的帮助。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t23、太平洋产险全国统一保险消费投诉电话：95500-3-4。\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }